import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const runtimeConfig = window.__CONFIG__ || {};

const environment =
  runtimeConfig.REACT_APP_ENVIRONMENT ||
  process.env.REACT_APP_ENVIRONMENT ||
  'development';

const firebaseConfig = {
  apiKey: environment === 'production'
    ? (runtimeConfig.REACT_APP_FIREBASE_API_KEY_PROD ||
       process.env.REACT_APP_FIREBASE_API_KEY_PROD ||
       '')
    : (runtimeConfig.REACT_APP_FIREBASE_API_KEY_DEV ||
       process.env.REACT_APP_FIREBASE_API_KEY_DEV ||
       ''),
  authDomain: environment === 'production'
    ? (runtimeConfig.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD ||
       process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD ||
       '')
    : (runtimeConfig.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV ||
       process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV ||
       ''),
  projectId: environment === 'production'
    ? (runtimeConfig.REACT_APP_FIREBASE_PROJECT_ID_PROD ||
       process.env.REACT_APP_FIREBASE_PROJECT_ID_PROD ||
       '')
    : (runtimeConfig.REACT_APP_FIREBASE_PROJECT_ID_DEV ||
       process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV ||
       ''),
  storageBucket: environment === 'production'
    ? (runtimeConfig.REACT_APP_FIREBASE_STORAGE_BUCKET_PROD ||
       process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PROD ||
       '')
    : (runtimeConfig.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV ||
       process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV ||
       ''),
  messagingSenderId: environment === 'production'
    ? (runtimeConfig.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PROD ||
       process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PROD ||
       '')
    : (runtimeConfig.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DEV ||
       process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DEV ||
       ''),
  appId: environment === 'production'
    ? (runtimeConfig.REACT_APP_FIREBASE_APP_ID_PROD ||
       process.env.REACT_APP_FIREBASE_APP_ID_PROD ||
       '')
    : (runtimeConfig.REACT_APP_FIREBASE_APP_ID_DEV ||
       process.env.REACT_APP_FIREBASE_APP_ID_DEV ||
       ''),
  measurementId: environment === 'production'
    ? (runtimeConfig.REACT_APP_FIREBASE_MEASUREMENT_ID_PROD ||
       process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_PROD ||
       '')
    : (runtimeConfig.REACT_APP_FIREBASE_MEASUREMENT_ID_DEV ||
       process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_DEV ||
       ''),
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { app, auth, googleProvider };
